var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreaStacked100(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.4 14.4a1.2 1.2 0 00-.8.2l-8.6 7-8.5 1.6-10.2-1.6a1 1 0 00-.7.2 1.2 1.2 0 00-.3.6v6.4a.8.8 0 00.8.8h28a.8.8 0 00.8-.8V15.2a.9.9 0 00-.5-.8z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.4
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1 0h-28a.8.8 0 00-.8.8v10.4a1 1 0 00.7.8l10.4 2.4h.1a.6.6 0 00.5-.2L20.6 8h8.5a.8.8 0 00.8-.8V.8a.8.8 0 00-.8-.8z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1 6.4h-8.8a.6.6 0 00-.5.2L11.4 13 1.3 10.4a1 1 0 00-.7.2.8.8 0 00-.3.6v17.6a.8.8 0 00.8.8h28a.8.8 0 00.8-.8V7.2a.8.8 0 00-.8-.8z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 25.1L1 23.5a1.2 1.2 0 01-1-1.1c0-.5.6-1 1-1L12 23l7.6-1.4 8.6-7a1 1 0 111.3 1.6l-9 7.3zM12.6 14.7L1 12.2a1 1 0 01-.9-1.3 1 1 0 011.3-.8l10.7 2.2L20 6.1H29a1 1 0 011.1 1 1 1 0 01-1 .9h-8.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaStacked100);
export default __webpack_public_path__ + "static/media/area-stacked-100.dc3afcd4.svg";
export { ForwardRef as ReactComponent };